import {
  AuthenticationRequestBuilder,
  CheckPartnerVitrin,
  DemoOptAuthenticationRequestBuilder,
  OptAuthenticationRequestBuilder,
  OptGenerateRequestBuilder,
} from '../authentication/authentication';
import Client from '../client';
import {VitrinClient} from '../client';

const token = localStorage.getItem('token') || '';

class LoginRepository {
  authentication = async (action: any) => {
    const {emailAddress, password, rememberMe} = action.payload;
    const makeAuthenticationRequest = new AuthenticationRequestBuilder()
      .data({
        emailAddress,
        password,
        rememberMe,
      })
      .build();
    const client = new Client(token);
    const response = await client.execute(makeAuthenticationRequest);
    return response;
  };

  generateOpt = async (action: any) => {
    const {phoneNumber, callback} = action.payload;
    const makeAuthenticationRequest = new OptGenerateRequestBuilder()
      .data({
        phoneNumber,
      })
      .build();
    const client = new Client(token);
    const response = await client.execute(makeAuthenticationRequest);
    return {response, callback};
  };

  generateDemoOpt = async (action: any) => {
    const {phoneNumber, callback} = action.payload;
    const makeAuthenticationRequest = new DemoOptAuthenticationRequestBuilder()
      .data({
        phoneNumber,
      })
      .build();
    const client = new Client(token);
    const response = await client.execute(makeAuthenticationRequest);
    return {response, callback};
  };

  verifyOpt = async (action: any) => {
    const {code, phoneNumber, rememberMe} = action.payload;
    const makeAuthenticationRequest = new OptAuthenticationRequestBuilder()
      .data({
        code,
        phoneNumber,
        rememberMe,
      })
      .build();
    const client = new Client(token);
    const response = await client.execute(makeAuthenticationRequest);
    return response;
  };

  getPartnerVitrin = async (action: any) => {
    const makeAuthenticationRequest = new CheckPartnerVitrin()
      .token(action.token)
      .build();
    const client = new VitrinClient(token);
    const response = await client.execute(makeAuthenticationRequest);
    return response;
  };
}

export default new LoginRepository();
